<div class="container">
  <div class="container-form">
    <div class="header">
      <img alt="" src="../../../assets/images/safe-gis-logo.svg" />
      <h1> Trocar a senha: </h1>
    </div>

    <form [formGroup]="form" (ngSubmit)="submitForm()" action="">
     <div class="container-input">
        <h4> Nova senha </h4>
        <input
          [type]="showPassword ? 'text' : 'password'"
          id="newPassword"
          name="newPassword"
          formControlName="newPassword"
          placeholder="Nova senha"
        />
        <button
          type="button"
          class="material-icons"
          (click)="togglePasswordVisibility()"
        >
          {{ showPassword ? 'visibility_off' : 'visibility' }}
        </button>
        <span *ngIf="form.get('newPassword')?.invalid && form.get('newPassword')?.touched"> Campo obrigatório </span>
      </div>

      <div class="password-rules" *ngIf="showValidation">
        <h3>Regras: </h3>
        <ul>
          <li [ngClass]="{'success': !form.get('newPassword')?.errors?.['maiuscula'], 'error': form.get('newPassword')?.errors?.['maiuscula']}">
            1 letra maiúscula (A-Z)
          </li>
          <li [ngClass]="{'success': !form.get('newPassword')?.errors?.['minuscula'], 'error': form.get('newPassword')?.errors?.['minuscula']}">
            1 letra minúscula (a-z)
          </li>
          <li [ngClass]="{'success': !form.get('newPassword')?.errors?.['numeros'], 'error': form.get('newPassword')?.errors?.['numeros']}">
            1 número (0-9)
          </li>
          <li [ngClass]="{'success': !form.get('newPassword')?.errors?.['caractere'], 'error': form.get('newPassword')?.errors?.['caractere']}">
            1 caractere especial
          </li>
          <li [ngClass]="{'success': !form.get('newPassword')?.errors?.['tamanho'], 'error': form.get('newPassword')?.errors?.['tamanho']}">
            Mínimo de 8 caracteres
          </li>
        </ul>
      </div>

      <div class="container-button">
        <button type="submit" class="button green-outline">
          <img src="../../../assets/images/icons/arrow-white.svg" alt="">
          Confirmar
        </button>
        <button type="button" (click)="back()" class="button red-outline">
          <img src="../../../assets/images/icons/close-white.svg" alt="">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</div>
